import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { SiteMapActions } from '../actions/site-map.actions';
import { ContextActions } from '../actions/context.actions';

@Injectable()
export class SiteMapEffects {
  sitemapLoaded$;

  constructor(actions$: Actions) {
    this.sitemapLoaded$ = createEffect(() => {
      return actions$.pipe(
        ofType(ContextActions.loadSuccess),
        map((action) => {
          return SiteMapActions.setSitemap({
            nodes: action.initialAppContext.sitemapNodes || [],
          });
        }),
      );
    });
  }
}
